import { SalesBlockDefinition, SplitBlock } from 'client/courses/components/page-builder';
import * as ContentBlock from 'client/courses/components/page-builder/content-block';

import * as HeroBlock from './hero-block';
import * as AboutBlock from './about-block';
import * as CredentialsBlock from './credentials-block';
import * as ServicesBlock from './services-block';
import * as TestimonialsBlock from './testimonials-block';
import * as CTABlock from './cta-block';

export const blockDefinitions: Record<string, SalesBlockDefinition> = {
  // Core blocks
  [ContentBlock.type]: ContentBlock,
  [SplitBlock.type]: SplitBlock,

  // Calendar-specific blocks
  [HeroBlock.type]: HeroBlock,
  [AboutBlock.type]: AboutBlock,
  [CredentialsBlock.type]: CredentialsBlock,
  [ServicesBlock.type]: ServicesBlock,
  [TestimonialsBlock.type]: TestimonialsBlock,
  [CTABlock.type]: CTABlock,
};
